module.exports = __webpack_public_path__ + "img/paas_01.5f6b281e.svg";